module.exports = __webpack_public_path__ + "static/media/Jackpot_Fishing.1455c41c.png";